import { useCallback, useState } from 'react';
import { Button, Typography } from '@mui/material';
import UploadIcon from '@mui/icons-material/Upload';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDispatch } from 'react-redux';

import {
  AccordionComponent,
  AccordionSummaryComponent,
  AccordionDetailsComponent,
} from 'app/components/StyledComponents';
import { notificationAlertActions } from 'app/pages/NotificationAlert/slice';

import UploadModal from './UploadModal';

interface CdpRawDataUploadSectionProps {
  defaultExpanded?: boolean;
}

export const CdpRawDataUploadSection = ({
  defaultExpanded = true,
}: CdpRawDataUploadSectionProps) => {
  const dispatch = useDispatch();
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

  const handleUploadSuccess = useCallback(() => {
    dispatch(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'success',
        message: 'Raw data upload started successfully',
      }),
    );
    setIsUploadModalOpen(false);
  }, [dispatch]);

  return (
    <>
      <AccordionComponent
        defaultExpanded={defaultExpanded}
        elevation={0}
        data-guidance-tour="configure-cdp-upload-raw-data"
        sx={{
          width: '100%',
          '&::before': {
            display: 'none',
          },
          padding: '16px',
        }}
      >
        <AccordionSummaryComponent
          expandIcon={<ExpandMoreIcon />}
          aria-controls="cdp-upload-raw-data-content"
          id="cdp-upload-raw-data-header"
        >
          <Typography variant="h6" gutterBottom component="div">
            Upload Raw Data
          </Typography>
        </AccordionSummaryComponent>
        <AccordionDetailsComponent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Upload CRM lead files to populate CDP data for nurturing plan initialization.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setIsUploadModalOpen(true)}
            startIcon={<UploadIcon />}
            sx={{ textTransform: 'none', mt: '25px' }}
          >
            Upload Raw Data
          </Button>
        </AccordionDetailsComponent>
      </AccordionComponent>

      <UploadModal
        open={isUploadModalOpen}
        onClose={() => setIsUploadModalOpen(false)}
        onUploadSuccess={handleUploadSuccess}
      />
    </>
  );
};

export default CdpRawDataUploadSection;
